"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapSerializerInRuleHeaderV2 = exports.getRuleHeaderV2Serializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const ruleType_1 = require("./ruleType");
const getRuleHeaderV2Serializer = () => (0, serializers_1.struct)([
    ['type', (0, serializers_1.u32)()],
    ['length', (0, serializers_1.u32)()],
]);
exports.getRuleHeaderV2Serializer = getRuleHeaderV2Serializer;
const wrapSerializerInRuleHeaderV2 = (type, serializer) => {
    const typeAsString = (0, ruleType_1.getRuleTypeV2AsString)(type);
    const headerSerializer = (0, exports.getRuleHeaderV2Serializer)();
    return {
        description: typeAsString,
        fixedSize: serializer.fixedSize === null ? null : serializer.fixedSize + 8,
        maxSize: serializer.maxSize === null ? null : serializer.maxSize + 8,
        serialize: (rule) => {
            const serializedRule = serializer.serialize(rule);
            const serializedHeader = headerSerializer.serialize({
                type,
                length: serializedRule.length,
            });
            return (0, serializers_1.mergeBytes)([serializedHeader, serializedRule]);
        },
        deserialize: (buffer, offset = 0) => {
            const [header] = headerSerializer.deserialize(buffer, offset);
            offset += 8;
            const slice = buffer.slice(offset, offset + header.length);
            const [rule] = serializer.deserialize(slice);
            return [{ ...rule, type: typeAsString }, offset + header.length];
        },
    };
};
exports.wrapSerializerInRuleHeaderV2 = wrapSerializerInRuleHeaderV2;
//# sourceMappingURL=ruleHeader.js.map